export enum LocaleEnum {
  DE = 'de',
  EN = 'en',
}
